import { wallet } from 'utils/wallet';
import FungibleTokens from './fungible-tokens';
import config from 'config';
const { OCC_CONTRACT, METHODS } = config;

const CHUNK_SIZE = 10;

const chunkArray = (arr, chunkSize) => {
  const results = [];
  while (arr.length) {
    results.push(arr.splice(0, chunkSize));
  }
  return results;
};

export default class NonFungibleTokens {
  static viewFunctionAccount = wallet.getAccountBasic.call(wallet, 'dontcare');

  static async getNftBalances({ accountId } : { accountId: string }) {
    try {
      let isPending = true;
      let fromIndex = 0;
      const limit = CHUNK_SIZE;
      const nftBalances = [];
    
      while (isPending) {
        const { nftBalances: nftBalancesChunk, numOfBalances } = await FungibleTokens.getProfileBalances({
          accountId,
          fromIndex: fromIndex.toString(),
          limit: limit.toString(),
        });
    
        isPending = numOfBalances === limit;
        fromIndex += limit;
        nftBalances.push(...nftBalancesChunk);
      }
    
      return nftBalances;
    } catch (e) {
      if (
        !e
          .toString()
          .includes('FunctionCallError(MethodResolveError(MethodNotFound))')
      ) {
        return [];
      }
    }
  }

  static getCertificates = async (nftBalances) => {
    const viewFunctionAccount = await this.viewFunctionAccount;
    return viewFunctionAccount.viewFunctionV1(
      OCC_CONTRACT,
      METHODS.get_certificates,
      { token_ids: nftBalances.map(([nftId]) => nftId) }
    );
  };

  static getAllCertificates = async ({ accountId } : { accountId: string }) => {
    const nftBalancesChunk = await this.getNftBalances({ accountId }).then((data) => chunkArray(data, CHUNK_SIZE));
    const certificates = [];
    
    for (let i = 0; i < nftBalancesChunk.length; i++) {
      const certificatesChunk = await this.getCertificates(nftBalancesChunk[i]);
      certificates.push(...certificatesChunk);
    }

    return certificates;
  };
}
